export const GENERAL = 'general';
export const NOTIFICATIONS = 'notifications';
export const TABLE_IMAGE = 'PieceTableImageClickBehavior';

export const PREVIEW = 'preview';
export const DETAILS = 'details';
